import { MeasuringUnitType } from "@/enums/MeasuringUnitType";

export class MeasuringUnit {
    static UNIT: MeasuringUnitType = MeasuringUnitType.FeetAndInches;
}